import React from "react"
import styled from "styled-components"
import { Flex } from "rebass"

const MaxWidth = styled(Flex)`
  max-width: 1120px;
`

MaxWidth.defaultProps = {
  mx: "auto",
  width: 1,
  px: 3,
}

export default MaxWidth



// WEBPACK FOOTER //
// ./src/components/MaxWidth/index.js